import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
const CuratorCarouselSlide = (props) => {
    const { t } = useTranslation();
    return (React.createElement("div", { className: "curator-carousel-slide__inner-slide" },
        React.createElement("button", { className: "curator-carousel-slide__img-holder", "aria-haspopup": "dialog" },
            React.createElement("img", { className: classNames('zoom-image-wrapper'), src: props.url, alt: t('curators.slide', { 0: props.current, 1: props.max }) }))));
};
export default CuratorCarouselSlide;
